export default __webpack_public_path__ + "static/media/iconbarb.000d5eb8.png";